import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { FINANCIAL_SETTINGS_SLICE_NAME, FinancialSettingsState } from './models';

export const financialSettingsSelector = (state: RootState): FinancialSettingsState =>
  state[FINANCIAL_SETTINGS_SLICE_NAME];

export const selectCashRegisters = createSelector(
  financialSettingsSelector,
  (state: FinancialSettingsState) => state.cashRegisters,
);

export const selectFinancialSettingsIsLoading = createSelector(
  financialSettingsSelector,
  (state: FinancialSettingsState) => state.isLoading,
);
